import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ReportsService } from '../reports/reports.service';
import { ElementData } from '../models/elementdata';
import { LimitsService } from '../limits/limits.service';
import { AttributeHeaders } from '../models/attributeheaders';
import { AttributesKeys } from '../models/attributekeys';
import { ModalData } from '../models/modaldata';
import { AlertService } from 'app/services';
import { NumberConstants } from "../common/numberconstants";
import { TranslateService } from '@ngx-translate/core';



@Component({
    selector: 'limitformmodal',
    styleUrls: ['./limitformmodal.component.scss'],
    templateUrl: './limitformmodal.component.html',
    providers: [ModalData]
})
export class LimitFormModalComponent {
    newLabelText: any = {};
    @Input() formTemplateData: any = {};
    @Output() onBtnSelection = new EventEmitter<boolean>();
    expanded = false;
    disabled = true;
    prodId: number;
    versionId: number;
    counts: Array<number> = [this.numberconstants.ONE];
    arrayOfStrings: any[];
    activeClass4: string;
    activeClass5: string;
    activeClass6: string;
    activeClass7: string;
    gForm4: string;
    gForm5: string;
    gForm6: string;
    gForm7: string;
    currentAutoCmpt: string;
    label: any;
    textareval:any;
    modalProps = {
        state: false,
        backdrop: true,
        title: this.translateService.instant('enterlabel'),
        Label: this.translateService.instant('newLabel'),
        LabelType: this.translateService.instant('newLabel'),
        bodyContent: " ",
        cancelButton: this.translateService.instant('cancel'),
        okButton: this.translateService.instant('create'),
        cancelBClass: "btn-outline",
        okBClass: "btn-primary",
        textPlaceHolder: this.translateService.instant('enterlabel'),
        textmaxlength: 5
    };
    categories:any;

    limitformModalHandler(btnOutput: boolean) {
        this.onBtnSelection.emit(btnOutput);
        this.formTemplateData.state = false;

    }

    constructor(private reportservice: ReportsService, private limitservice: LimitsService,
        private modalData: ModalData, private alertService: AlertService,private numberconstants: NumberConstants,private translateService: TranslateService) {
    }

    onChangeProd(selectedValue) {
        if (selectedValue.id > this.numberconstants.ZERO) {
            this.prodId = selectedValue.id;
            if (this.formTemplateData.isMaximum === false && selectedValue.isprod === true) {
                this.getSelProductVersions(selectedValue.id, selectedValue.isprod, this.numberconstants.ALLPRODUCTS);
                // Extract all product versionst
            } else if (this.formTemplateData.isMaximum === false && selectedValue.isprod === false) {
                this.getSelProductVersions(selectedValue.id, selectedValue.isprod, this.numberconstants.HASCONFIGSET);
                // Extract all new product versions which are having in config max set
            }
        }
    }

    modalAddHandler(e) {
        this.newLabelText = e;
        if (this.modalProps.LabelType === this.translateService.instant('newLabel')) {
            this.formTemplateData.elements[this.numberconstants.LABEL].selectedValue = e;
        } else if (this.modalProps.LabelType === this.translateService.instant('newConfiguration')) {
            this.formTemplateData.elements[this.numberconstants.LIMIT].selectedValue = e;
        } else {
            return false;
        }
        this.addAttrbutes(this.modalProps.LabelType);
    }

    onClicked(option, event) {
        if (option.value === this.translateService.instant('clone') || option.value === this.translateService.instant('update')) {
            if (option.value === this.translateService.instant('clone')) {
                this.setVersionArray([], this.numberconstants.CLONEVERSION, false);
                this.formTemplateData.elements[this.numberconstants.LIMIT].hidden = false;
                this.formTemplateData.elements[this.numberconstants.CLONEVERSION].hidden = false;
                this.formTemplateData.elements[this.numberconstants.CLONE].options[this.numberconstants.ZERO].isChecked = false;
                this.formTemplateData.elements[this.numberconstants.CLONE].options[this.numberconstants.ONE].isChecked = true;
            } else {
                this.formTemplateData.elements[this.numberconstants.LIMIT].hidden = true;
                this.formTemplateData.elements[this.numberconstants.CLONEVERSION].hidden = true;
                this.formTemplateData.elements[this.numberconstants.CLONE].options[this.numberconstants.ZERO].isChecked = true;
                this.formTemplateData.elements[this.numberconstants.CLONE].options[this.numberconstants.ONE].isChecked = false;

            }
        } else if (option.value === this.translateService.instant('yes') || option.value === this.translateService.instant('no')) {
            if (option.value === this.translateService.instant('yes')) {
                this.formTemplateData.elements[this.numberconstants.INTERNAL].options[this.numberconstants.ZERO].isChecked = true;
                this.formTemplateData.elements[this.numberconstants.INTERNAL].options[this.numberconstants.ONE].isChecked = false;
            } else {
                this.formTemplateData.elements[this.numberconstants.INTERNAL].options[this.numberconstants.ZERO].isChecked = false;
                this.formTemplateData.elements[this.numberconstants.INTERNAL].options[this.numberconstants.ONE].isChecked = true;

            }
        }

    }

    getSelProductVersions(prodId, isprod, urlIndex): void {
        this.reportservice.getProductVersions(prodId, urlIndex)
            .subscribe(vmwareproductsVersions => {
                let arr: any = new Array();
                if (vmwareproductsVersions.length === this.numberconstants.ZERO) {
                    this.disabled = true;
                } else {
                    this.disabled = false;
                    vmwareproductsVersions.forEach(element => {
                        arr.push({
                            id: element.id, value: element.rmVmwPrdRelVersion
                        });
                    });
                }

                if (this.formTemplateData.isMaximum === false && isprod === true) {
                    this.setVersionArray(arr, this.numberconstants.ONE, isprod);
                } else if (this.formTemplateData.isMaximum === false && isprod === false) {
                    this.setVersionArray(arr, this.numberconstants.FOUR, isprod);
                }
            },
                err => {
                    console.log(err)
                    if (this.formTemplateData.isMaximum === false && isprod === true) {
                        this.setVersionArray([], this.numberconstants.ONE, isprod);
                    } else if (this.formTemplateData.isMaximum === false && isprod === false) {
                        this.setVersionArray([], this.numberconstants.FOUR, isprod);
                    }
                });

    }

    setVersionArray(arr: any, index: number, isprod: boolean): void {
        let newarr: any = new Array();
        this.formTemplateData.elements[index].options = newarr;
        arr.forEach(element => {
            if (this.formTemplateData.elements[this.numberconstants.SELECTEDVERSION].selectedValue.id != element.id) {
                newarr.push({
                    id: element.id, value: element.value
                });
            }

        });
        this.formTemplateData.elements[index].options = newarr;
        this.formTemplateData.elements[index].selectedValue = newarr[this.numberconstants.SELECTEDOBJECT];
    }

    addPopupModal(event, label: any) {
        let btnId = event.target.id;
        this.modalProps.cancelButton = this.translateService.instant('cancel')
        this.modalProps.cancelBClass = "btn-outline";
        this.modalProps.okBClass = "btn-primary";
        switch (btnId) {
            case "gForm0":
                this.modalProps.title = this.translateService.instant('enterNewLabel');
                this.modalProps.Label = this.translateService.instant('enterlabel');
                this.modalProps.LabelType = this.translateService.instant('newLabel');
                this.modalProps.textPlaceHolder = this.translateService.instant('enterlabel');
                this.modalProps.textmaxlength = this.numberconstants.TEXTLENGTH_255;
                break;
            case "gForm2":
                this.modalProps.title = this.translateService.instant('enterNewConfiguartion');
                this.modalProps.Label = this.translateService.instant('enterConfiguration');
                this.modalProps.LabelType = this.translateService.instant('newConfiguration');
                this.modalProps.textPlaceHolder = this.translateService.instant('enterConfiguration');
                this.modalProps.textmaxlength = this.numberconstants.TEXTLENGTH_500;
                break;
        }
        this.modalProps.state = true;
    }

    addAttrbutes(label: any) {
        let currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
        if (label === this.translateService.instant('newLabel')) {
            let header: AttributeHeaders = new AttributeHeaders();
            if (this.formTemplateData.elements[this.numberconstants.ONE].selectedValue.length > this.numberconstants.ZERO) {
                header.attrHeader = this.formTemplateData.elements[this.numberconstants.ONE].selectedValue.trim();
                header.categoryId = this.reportservice.catId;
                header.description = this.formTemplateData.elements[this.numberconstants.ONE].selectedValue;
                header.lastUpdate = new Date();
                header.subCategoryId = this.reportservice.subcatId;
                header.type = "C";
                header.updatedBy = currentUser.userName;
                let arr = this.formTemplateData.elements[this.numberconstants.ZERO].options;
                var keyExists: number = this.checkValue(arr, header.attrHeader)
                if (keyExists == this.numberconstants.MINUS_ONE) {
                    arr.push({
                        id: this.numberconstants.MINUS_ONE, value: header.attrHeader
                    });
                    keyExists = arr.length - this.numberconstants.ONE;
                }
                this.formTemplateData.elements[this.numberconstants.HEAD].options = arr;
                this.formTemplateData.elements[this.numberconstants.HEAD].selectedValue = arr[keyExists];
                this.formTemplateData.elements[this.numberconstants.LABEL].hidden = true;
            }
        } else if (label === this.translateService.instant('newConfiguration')) {
            if (this.formTemplateData.elements[this.numberconstants.LIMIT].selectedValue.length > this.numberconstants.ZERO) {
                let attrkey: AttributesKeys = new AttributesKeys();
                attrkey.id = this.numberconstants.ZERO;
                attrkey.attributeKey = this.formTemplateData.elements[this.numberconstants.LIMIT].selectedValue.trim();
                attrkey.lastUpdate = new Date();
                attrkey.updatedBy = currentUser.userName;
                let arr = this.formTemplateData.elements[this.numberconstants.KEYOBJECT].options;
                var keyExists: number = this.checkValue(arr, attrkey.attributeKey)
                if (keyExists == this.numberconstants.MINUS_ONE) {
                    arr.push({
                        id: this.numberconstants.ZERO, value: attrkey.attributeKey
                    });
                    keyExists = arr.length - this.numberconstants.ONE;
                }
                this.formTemplateData.elements[this.numberconstants.KEYOBJECT].options = arr;
                this.formTemplateData.elements[this.numberconstants.KEYOBJECT].selectedValue = arr[keyExists];
                this.formTemplateData.elements[this.numberconstants.LIMIT].hidden = true;
            }
        }
    }

    checkValue(arr: any, value: String) {
        if (arr != undefined || value != undefined) {
            for (let i: number = this.numberconstants.ZERO; i < arr.length; i++) {
                var element = arr[i];
                if (element.value === value) {
                    return i;
                }
            }
        }
        return this.numberconstants.MINUS_ONE;

    }
    addAttributeHeaders(header: AttributeHeaders): any {
        let arr: any = new Array();
        this.limitservice.addHeaders(header, this.reportservice.selectedprodID, this.reportservice.selectedversionID)
            .subscribe(headers => {
                if (headers.status && headers.status === "OK") {
                    this.formTemplateData.elements[this.numberconstants.ONE].selectedValue = "";
                    this.getAttributeHeaders();
                }
            },
                err => {
                    console.log(err);
                });
        return arr;
    }
    getAttributeHeaders(): any {
        let arr: any = new Array();
        this.limitservice.getHeaders(this.reportservice.catId, this.reportservice.subcatId,
            this.reportservice.selectedprodID, this.reportservice.selectedversionID)
            .subscribe(headers => {
                if (headers.length === this.numberconstants.ZERO) {
                    this.disabled = true;
                } else {
                    this.disabled = false;
                    headers.forEach(element => {
                        if (element.attrHeader.length > this.numberconstants.ZERO) {
                            arr.push({
                                id: element.id, value: element.attrHeader
                            });
                        }
                    });
                }
                arr.push({
                    id: this.numberconstants.ZERO, value: this.translateService.instant('selectHeaderLabel')
                });
                this.formTemplateData.elements[this.numberconstants.HEAD].options = arr;
                this.formTemplateData.elements[this.numberconstants.HEAD].selectedValue = arr[arr.length - this.numberconstants.TWO];
            },
                err => {
                    // Log errors if any
                    console.log(err)

                });
        return arr;
    }

    getAttributeKeys(): any {
        let arr: any = new Array();
        this.limitservice.getAttrKeys(this.reportservice.selectedprodID)
            .subscribe(attrkeys => {
                if (attrkeys.length === this.numberconstants.ZERO) {
                    this.disabled = true;
                } else {
                    this.disabled = false;
                    attrkeys.forEach(element => {
                        arr.push({
                            id: element.id, value: element.attributeKey
                        });
                    });
                    this.formTemplateData.elements[this.numberconstants.KEYOBJECT].options = arr;
                    this.formTemplateData.elements[this.numberconstants.KEYOBJECT].selectedValue = arr[arr.length - this.numberconstants.ONE];
                }

            },
                err => {
                    console.log(err)
                });
        return arr;
    }

    getSuggestData(event: any) { // without type info
        this.currentAutoCmpt = event.target.id;
        if (event.target.value == '') {
            this.activeClass4 = '';
            this.activeClass5 = '';
            this.activeClass6 = '';
            this.activeClass7 = '';
        } else {
            if (event.target.id == 'gForm4') {
                this.activeClass4 = 'active';
                this.activeClass5 = '';
                this.activeClass6 = '';
                this.activeClass7 = '';
            } else if (event.target.id == 'gForm5') {
                this.activeClass4 = '';
                this.activeClass5 = 'active';
                this.activeClass6 = '';
                this.activeClass7 = '';
            } else if (event.target.id == 'gForm6') {
                this.activeClass4 = '';
                this.activeClass5 = '';
                this.activeClass6 = 'active';
                this.activeClass7 = '';
            } else if (event.target.id == 'gForm7') {
                this.activeClass4 = '';
                this.activeClass5 = '';
                this.activeClass6 = '';
                this.activeClass7 = 'active';
            }
            this.reportservice.getSuggestData(event.target.value)
                .subscribe(suggestData => {
                    this.arrayOfStrings = suggestData;
                },
                    err => {
                        // Log errors if any
                        console.log(err);
                    });
        }
    }

    closeDrpDwn() {
        if (this.currentAutoCmpt == 'gForm4') {
            this.activeClass4 = '';
        } else if (this.currentAutoCmpt == 'gForm5') {
            this.activeClass5 = '';
        } else if (this.currentAutoCmpt == 'gForm6') {
            this.activeClass6 = '';
        } else if (this.currentAutoCmpt == 'gForm7') {
            this.activeClass7 = '';
        }
    }

    showDiv(element): boolean {
        this.checkMandatory();
        if (element.label === this.translateService.instant('manLimits.performanceMember') ||
            element.label === this.translateService.instant('manLimits.qeMember') ||
            element.label === this.translateService.instant('manLimits.devMember') ||
            element.label === this.translateService.instant('manLimits.prodManager')) {
            return false;
        } else {
            return true;
        }
    }

    onVersionChange(element: string) {
        this.versionId = element["id"];
        this.formTemplateData.title = this.translateService.instant('update') + element["value"];
    }

    checkMandatory(): void {
        if ( (this.formTemplateData.elements[this.numberconstants.PUBLISHVAL] && this.formTemplateData.elements[this.numberconstants.PUBLISHVAL].label === this.translateService.instant('manLimits.publishLimit') &&
            this.formTemplateData.elements[this.numberconstants.PUBLISHVAL].selectedValue.length > this.numberconstants.ZERO) &&
            (this.formTemplateData.elements[this.numberconstants.PRODAUTHOR] && this.formTemplateData.elements[this.numberconstants.PRODAUTHOR].label === this.translateService.instant('manLimits.prodManager') &&
                this.formTemplateData.elements[this.numberconstants.PRODAUTHOR].selectedValue.length > this.numberconstants.ZERO) || (this.formTemplateData.okButton == this.translateService.instant('assign')) ) {
            this.disabled = false;
        } else {
            if ((this.formTemplateData.elements[this.numberconstants.SELECTEDOBJECT].label === this.translateService.instant('product') &&
                this.formTemplateData.elements[this.numberconstants.SELECTEDOBJECT].selectedValue.id > this.numberconstants.ZERO)
                && (this.formTemplateData.elements[this.numberconstants.SELECTEDVERSION].label === this.translateService.instant('manLimits.version') &&
                    this.formTemplateData.elements[this.numberconstants.SELECTEDVERSION].selectedValue.id > this.numberconstants.ZERO)) {
                this.disabled = false;
            }
            else
                this.disabled = true;
        }
    }

    isdisabled():boolean {
       return this.disabled;
    }

    onChangeSort(selectedValue) {
    this.reportservice.getMaximumCategoriesByProductIdAndVersionId(this.prodId, this.versionId)
        .subscribe(vmwareproductsMaximums => {
            console.log(vmwareproductsMaximums);            
        },
            err => {
                // Log errors if any
                console.log(err)
            });

    }
}



// WEBPACK FOOTER //
// ./src/app/limits/limitformmodal.component.ts